import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "services" }
const _hoisted_2 = { class: "services-grid" }
const _hoisted_3 = { class: "service-media" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "service-icon" }
const _hoisted_6 = { class: "service-more" }

import { AlertTriangle, ArrowRight, Hammer, Home, Layers, ShieldCheck, Wrench } from "lucide-vue-next";
import { services } from "@/data/services";
import "@/assets/styles/service.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceView',
  setup(__props) {

const icons = [Home, ShieldCheck, Wrench, Layers, Hammer, AlertTriangle];

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("header", { class: "services-header" }, [
      _createElementVNode("span", { class: "section-badge" }, "Leistungen"),
      _createElementVNode("h1", null, "Was wir für Ihr Dach tun"),
      _createElementVNode("p", null, "Wählen Sie eine Leistung aus und erfahren Sie mehr über Umfang, Vorteile und den konkreten Ablauf.")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(services), (service, index) => {
        return (_openBlock(), _createBlock(_component_RouterLink, {
          key: service.slug,
          to: `/leistungen/${service.slug}`,
          class: "service-card",
          "aria-label": `${service.title}: Details ansehen`
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: `/images/services/${service.slug}.png`,
                alt: `${service.title} – Dachdecker bei der Arbeit`,
                loading: "lazy"
              }, null, 8, _hoisted_4)
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(icons[index])))
            ]),
            _createElementVNode("h2", null, _toDisplayString(service.title), 1),
            _createElementVNode("p", null, _toDisplayString(service.short), 1),
            _createElementVNode("span", _hoisted_6, [
              _cache[0] || (_cache[0] = _createTextVNode("Mehr erfahren ", -1)),
              _createVNode(_unref(ArrowRight))
            ])
          ]),
          _: 2
        }, 1032, ["to", "aria-label"]))
      }), 128))
    ])
  ]))
}
}

})